export interface ConnectFacebookAccountDto {
  code: string;
}

export interface FacebookAccount {
  _id: string;
  user: string;
  name: string;
  pageId: string;
  permissions: FacebookAccountPermission[];
  accessRevokedDate?: number;
}

export enum FacebookAccountPermission {
  PUBLIC_PROFILE = 'public_profile',
  PAGES_MESSAGING = 'pages_messaging',
  PAGES_SHOW_LIST = 'pages_show_list',
  PAGES_MANAGE_METADATA = 'pages_manage_metadata'
}

export enum FacebookAccountHighLevelPermissionType {
  MESSAGING = 'messaging'
}
